// extracted by mini-css-extract-plugin
export default {"header":"styles_header__s4OIF","close":"styles_close__of3pf","body":"styles_body__igYlq"};